<template>
    <div class='errorPageLayout'>
        <div class="error-img">
            <img :src="logoURL" alt="Error">
        </div>
        <div class="errorPageLowerDiv">
            <div class="errorPageContentDiv">
                <div class="errorPageHeading" v-html="heading">
                </div>
                <div v-if="description" class="errorPageDescription" v-html="description">
                </div>
            </div>
            <div class="errorPageBackBtn">
                <button type="button" class="errorPageBtnClass" @click="goToLandingPage">
                    {{buttonText}}
                </button>
                <button v-if="hasDashboardRoute" type="button" class="errorPageBtnClass" @click="goToDashboard">
                    {{ $t('pages.error_pages.back_to_dashboard_btn') }}
                </button>
            </div>
        </div>

        <div class="errorPageFooterContainer" v-if="currentRouteName !== '403'">
        <div class="error404-message" v-if="currentRouteName === '404'" v-html="$t('pages.error_pages.404_alternate_heading')"></div>
        <div class="errorPageFooter">
            <div class="errorPageFooter__GetHelp errorPageFooter__container">
                <div class="errorPageFooter__container__title">
                    {{ $t('pages.error_pages.footer.get_help.title') }}
                </div>
                <div class="errorPageFooter__container__description errorPageFooter__GetHelp__description">
                    {{ $t('pages.error_pages.footer.get_help.description') }}
                </div>
                <div class="errorPageFooter__container__link">
                    <a href="https://foundrysupport.monotype.com/hc/en-us" target="_blank">{{ $t('pages.error_pages.footer.get_help.link') }}</a>
                </div>
            </div>
            <div class="errorPageFooter__ViewDashboard errorPageFooter__container">
                <div class="errorPageFooter__container__title">
                    {{ $t('pages.error_pages.footer.view_dashboard.title') }}
                </div>
                <div class="errorPageFooter__container__description">
                    {{ $t('pages.error_pages.footer.view_dashboard.description') }}
                </div>
                <div class="errorPageFooter__container__link">
                    <a :href="showDashboard">{{ $t('pages.error_pages.footer.view_dashboard.link') }}</a>
                </div>
            </div>
            <div class="errorPageFooter__LearnMore errorPageFooter__container">
                <div class="errorPageFooter__container__title">
                    {{ $t('pages.error_pages.footer.learn_more.title') }}
                </div>
                <div class="errorPageFooter__container__description">
                    {{ $t('pages.error_pages.footer.learn_more.description') }}
                </div>
                <div class="errorPageFooter__container__link">
                    <a :href="ufda2Status ? 'https://fontplatform.monotype.com/content/resources/educational-article' : 'https://fontplatform.monotype.com/content/team'" target="_blank" rel="noopener noreferrer">{{ $t('pages.error_pages.footer.learn_more.link') }}</a>
                </div>
            </div>
        </div>
        </div>
    </div>
</template>